import { Box, MenuItem, TextField, Typography } from "@mui/material";

export interface SelectAnnotatedOption {
  value: string;
  label: string;
  desc: string;
}

interface Props {
  options: SelectAnnotatedOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  name?: string;
  id?: string;
}

/**
 * Select con dos líneas por opción: `label` en tono prominente y `desc` en tono secundario.
 * El estado cerrado replica el mismo estilo: label en negrita oscura y desc atenuado.
 */
export const SelectAnnotated = ({ options, value, onChange, disabled, name, id }: Props) => (
  <TextField
    select
    size="lendia_input"
    fullWidth
    value={value}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled}
    name={name}
    id={id}
    SelectProps={{
      renderValue: (v) => {
        const opt = options.find((o) => o.value === v);
        if (!opt) return "";
        return (
          <Box component="span" sx={{ display: "flex", gap: "6px", alignItems: "baseline" }}>
            <Typography component="span" sx={{ fontSize: 14, fontWeight: 500, color: "primary.dark" }}>
              {opt.label}
            </Typography>
            <Typography component="span" sx={{ fontSize: 13, color: "tokens.textSecondary" }}>
              — {opt.desc}
            </Typography>
          </Box>
        );
      },
    }}
  >
    {options.map((opt) => (
      <MenuItem key={opt.value} value={opt.value} sx={{ py: 1.5 }}>
        <Box>
          <Typography sx={{ fontSize: 14, fontWeight: 500, color: value === opt.value ? "primary.main" : "primary.dark" }}>
            {opt.label}
          </Typography>
          <Typography sx={{ fontSize: 12, color: "primary.main", mt: "1px" }}>{opt.desc}</Typography>
        </Box>
      </MenuItem>
    ))}
  </TextField>
);
